<template>
    <DialogComponent
        rejectLabel="not now"
        @cancel="onCancel"
        @continue="onContinue"
    >
        <Intro
            v-if="hasIdCardIntro"
            :daysRemaining="daysRemaining"
            :isWithdrawal="true"
        />
        <br>
        <div v-if="hasDepositIntro">
            {{ $t('You first need to make a deposit before doing any withdrawals') }}
        </div>
    </DialogComponent>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Modals from '@store/modules/ui/shared/modal/modals';
    import Intro from '@modules/userProfile/idCardVerification/components/Intro';
    import { routeNames } from '@app/router';
    import { idCardRemainingDays } from '@countryModels/user/UserDataService';
    import DialogComponent from '../../components/DialogComponent';

    export default {
        name: 'WithdrawalIntroModal',
        created() {
            this.hasIdCardIntro = this.modalData.hasIdCardIntro;
            this.hasDepositIntro = this.modalData.hasDepositIntro;
            this.daysRemaining = idCardRemainingDays(this.user);
        },
        data() {
            return {
                userHasChooseContinue: false,
            };
        },
        computed: {
            ...mapGetters('ui/modal', [
                'modalData',
            ]),
            ...mapGetters('data/authentication', [
                'user',
            ]),
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
                'closeAllModals',
            ]),
            onCancel() {
                this.closeAllModals();
            },
            onContinue() {
                this.userHasChooseContinue = true;
                if (this.hasIdCardIntro) {
                    this.setModal(Modals.idCardVerification.code);
                } else {
                    this.$router.push({ name: routeNames.deposit });
                    this.closeAllModals();
                }
            },
        },
        destroyed() {
            if (!this.userHasChooseContinue) {
                this.$router.push({ name: routeNames.profile });
            }
        },
        components: {
            Intro,
            DialogComponent,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modals/modals/userProfile/withdrawal/WithdrawalIntroModal.vue